import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import ProtectedRoute from "./routes/ProtectedRoute";

import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import GalleryPage from './pages/GalleryPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import AdvertisementPage from './pages/user/AdvertisementPage';
import MyAdvertisementPage from './pages/user/MyAdvertisementPage';
import CreateAdvertisementPage from './pages/user/CreateAdvertisementPage';
import PostPage from './pages/PostPage';
import MyPostPage from './pages/user/MyPostPage';
import CreatePostPage from './pages/user/CreatePostPage';
import JobPage from './pages/JobPage';
import JobDetailsPage from './pages/JobDetailsPage';
import MyJobPage from './pages/MyJobPage';
import CreateJobPage from './pages/user/CreateJobPage';
import MembersPage from './pages/MembersPage';
import MembersDetailsPage from './pages/MembersDetailsPage';
import ProfilePage from './pages/ProfilePage';
import SmoothScroll from './SmoothScroll';
import PostViewPage from './pages/PostViewPage';
import ViewAdvertisementPage from './pages/user/ViewAdvertisementPage';
import GalleryMainPage from './pages/GalleryMainPage';

function App() { 

  return (
    <BrowserRouter>
      <SmoothScroll>
        <Routes>
          <Route path="/">
            <Route path="/" element={<HomePage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/gallery/:id" element={<GalleryMainPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/advertisement" element={<ProtectedRoute><AdvertisementPage /></ProtectedRoute>} />
            <Route path="/my-advertisement" element={<ProtectedRoute><MyAdvertisementPage /></ProtectedRoute>} />
            <Route path="/create-advertisement" element={<ProtectedRoute><CreateAdvertisementPage /></ProtectedRoute>} />
            <Route path="/advertisement/edit/:id" element={<ProtectedRoute><CreateAdvertisementPage /></ProtectedRoute>} />
            <Route path="/advertisement/view/:id" element={<ProtectedRoute><ViewAdvertisementPage /></ProtectedRoute>} />

            <Route path="/posts" element={<ProtectedRoute><PostPage /></ProtectedRoute>} />
            <Route path="/my-posts" element={<ProtectedRoute><MyPostPage /></ProtectedRoute>} />
            <Route path="/create-post" element={<ProtectedRoute><CreatePostPage /></ProtectedRoute>} />
            <Route path="/post/edit/:id" element={<ProtectedRoute><CreatePostPage /></ProtectedRoute>} />
            <Route path="/post/view/:id" element={<ProtectedRoute><PostViewPage /></ProtectedRoute>} />

            <Route path="/jobs" element={<ProtectedRoute><JobPage /></ProtectedRoute>} />
            <Route path="/job/view/:id" element={<ProtectedRoute><JobDetailsPage /></ProtectedRoute>} />

            <Route path="/my-jobs" element={<ProtectedRoute><MyJobPage /></ProtectedRoute>} />
            <Route path="/create-job" element={<ProtectedRoute><CreateJobPage /></ProtectedRoute>} />
            <Route path="/job/edit/:id" element={<ProtectedRoute><CreateJobPage /></ProtectedRoute>} />

            <Route path="/members" element={<ProtectedRoute><MembersPage /></ProtectedRoute>} />
            <Route path="/member/:id" element={<ProtectedRoute><MembersDetailsPage /></ProtectedRoute>} />

            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />

            <Route path="/profile" element={<ProtectedRoute ><ProfilePage /></ProtectedRoute>} />
          </Route>
        </Routes>
      </SmoothScroll>
    </BrowserRouter>
  );
}

export default App;
